import { apiFetch, getAuthorizationHeaders } from 'utils/fetch';
import { MetaDataAttributes } from 'models';
import * as config from 'config';

export async function fetchAllMetaData(): Promise<MetaDataAttributes> {
  const headers = getAuthorizationHeaders();
  const url = `${config.backendApi}/metadata`;

  const json = await apiFetch<any>(url, { headers });

  return json.data.attributes;
}
